import { FunctionComponent, ReactNode } from 'react'
import type { GtmAttributes } from '../../../../domain/shared/types/gtm.types'

type CtaProps = {
  onClick: () => void
  label: string
  icon: ReactNode
  disabled?: boolean
} & GtmAttributes

export const Cta: FunctionComponent<CtaProps> = ({
  onClick,
  label,
  icon,
  disabled = false,
  'data-gtm': dataGtm,
  'data-gtm-label': dataGtmLabel,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="ml-4 bg-emerald-500 hover:bg-emerald-600 disabled:bg-gray-400 disabled:cursor-not-allowed p-2 md:py-3 md:px-4 rounded-full shadow-lg transition-colors font-medium flex items-center gap-2"
    data-gtm={dataGtm}
    data-gtm-label={dataGtmLabel}
  >
    {icon}
    <span className="hidden md:inline text-white">{label}</span>
  </button>
)
